/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AccountsInputs */

const th_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีผู้ใช้`)
};

const en_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts`)
};

const ja_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

const zh_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户`)
};

const es_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuentas`)
};

const pt_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contas`)
};

const id_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun`)
};

const fr_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptes`)
};

const tl_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga account`)
};

const vi_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản`)
};

const ko_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정`)
};

const de_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten`)
};

const ru_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунты`)
};

const tr_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesaplar`)
};

const it_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pl_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konta`)
};

const uk_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облікові записи`)
};

const hi_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाते`)
};

const ar_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحسابات`)
};

const ms_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun`)
};

const bn_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাকাউন্ট`)
};

const zh_tw2_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帳戶`)
};

const zh_hk2_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帳戶`)
};

const ur_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اکاؤنٹس`)
};

const fa_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب‌ها`)
};

const sw_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti`)
};

const nl_accounts = /** @type {(inputs: AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts`)
};

/**
* | output |
* | --- |
* | "Accounts" |
*
* @param {AccountsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const accounts = /** @type {((inputs?: AccountsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AccountsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_accounts(inputs)
	if (locale === "ja") return ja_accounts(inputs)
	if (locale === "zh") return zh_accounts(inputs)
	if (locale === "es") return es_accounts(inputs)
	if (locale === "pt") return pt_accounts(inputs)
	if (locale === "id") return id_accounts(inputs)
	if (locale === "fr") return fr_accounts(inputs)
	if (locale === "tl") return tl_accounts(inputs)
	if (locale === "vi") return vi_accounts(inputs)
	if (locale === "ko") return ko_accounts(inputs)
	if (locale === "de") return de_accounts(inputs)
	if (locale === "ru") return ru_accounts(inputs)
	if (locale === "tr") return tr_accounts(inputs)
	if (locale === "it") return it_accounts(inputs)
	if (locale === "pl") return pl_accounts(inputs)
	if (locale === "uk") return uk_accounts(inputs)
	if (locale === "hi") return hi_accounts(inputs)
	if (locale === "ar") return ar_accounts(inputs)
	if (locale === "ms") return ms_accounts(inputs)
	if (locale === "bn") return bn_accounts(inputs)
	if (locale === "zh-TW") return zh_tw2_accounts(inputs)
	if (locale === "zh-HK") return zh_hk2_accounts(inputs)
	if (locale === "ur") return ur_accounts(inputs)
	if (locale === "fa") return fa_accounts(inputs)
	if (locale === "sw") return sw_accounts(inputs)
	if (locale === "nl") return nl_accounts(inputs)
	return en_accounts(inputs)
});